import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

export const Svg = createReactClass({
    propTypes: {
        icon: PropTypes.string.isRequired,
        iconFamily: PropTypes.string,

        additionalClasses: PropTypes.string,
        attributes: PropTypes.object,
    },

    render: function () {
        let iconFamily = this.props.iconFamily;

        if (iconFamily == null) {
            iconFamily = 'junior';
        }

        return (
            <svg {...this.props.attributes} className={'icon icon-' + this.props.icon + ' ' + this.props.additionalClasses }><use xlinkHref={'/images/icon/icon-' + iconFamily + '.svg#icon-' + this.props.icon}></use></svg>
        );
    },
});
